export default __webpack_public_path__ + "static/media/ic_grid.692b4765.svg";